import { render } from "./Preferences.vue?vue&type=template&id=362b2ab8&scoped=true"
import script from "./Preferences.vue?vue&type=script&lang=js"
export * from "./Preferences.vue?vue&type=script&lang=js"

import "./Preferences.vue?vue&type=style&index=0&id=362b2ab8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-362b2ab8"]])

export default __exports__